var map = {
	"./beauty-uber": 4,
	"./beauty-uber.png": 4,
	"./bungalow": 5,
	"./bungalow.jpg": 5,
	"./charity": 6,
	"./charity-2": 7,
	"./charity-2.jpg": 7,
	"./charity.jpg": 6,
	"./collage-1": 8,
	"./collage-1.jpg": 8,
	"./cuk": 1,
	"./cuk-dark": 9,
	"./cuk-dark.png": 9,
	"./cuk.jpg": 50,
	"./cuk.png": 1,
	"./eedn-image": 10,
	"./eedn-image.png": 10,
	"./eedn-logo": 11,
	"./eedn-logo.png": 11,
	"./facebook-image": 12,
	"./facebook-image.jpg": 12,
	"./grey-caret-left": 13,
	"./grey-caret-left.svg": 13,
	"./grey-paul": 14,
	"./grey-paul.jpg": 14,
	"./house": 15,
	"./house.jpg": 15,
	"./journey": 16,
	"./journey.jpg": 16,
	"./jpd-logo": 17,
	"./jpd-logo.png": 17,
	"./model": 18,
	"./model.jpg": 18,
	"./my-journey": 19,
	"./my-journey.jpg": 19,
	"./project-2": 20,
	"./project-2.png": 20,
	"./singh": 2,
	"./singh.jpg": 51,
	"./singh.png": 2,
	"./slider-1": 21,
	"./slider-1.jpg": 21,
	"./symbols/black-caret-left": 22,
	"./symbols/black-caret-left.svg": 22,
	"./symbols/black-caret-right": 23,
	"./symbols/black-caret-right.svg": 23,
	"./symbols/blue-caret-left": 24,
	"./symbols/blue-caret-left.svg": 24,
	"./symbols/burger": 25,
	"./symbols/burger.svg": 25,
	"./symbols/cuk-colored": 26,
	"./symbols/cuk-colored.svg": 26,
	"./symbols/cuk-logo": 27,
	"./symbols/cuk-logo.png": 27,
	"./symbols/dark-blue-arrow-right": 28,
	"./symbols/dark-blue-arrow-right.svg": 28,
	"./symbols/diagonal-arrow": 3,
	"./symbols/diagonal-arrow.png": 3,
	"./symbols/diagonal-arrow.svg": 52,
	"./symbols/eedn-logo": 29,
	"./symbols/eedn-logo.png": 29,
	"./symbols/facebook": 30,
	"./symbols/facebook.svg": 30,
	"./symbols/grey-caret-left": 31,
	"./symbols/grey-caret-left.svg": 31,
	"./symbols/instagram": 32,
	"./symbols/instagram.svg": 32,
	"./symbols/next-button": 33,
	"./symbols/next-button.svg": 33,
	"./symbols/paul-singh-group-logo": 34,
	"./symbols/paul-singh-group-logo.svg": 34,
	"./symbols/play-button": 35,
	"./symbols/play-button.svg": 35,
	"./symbols/scroll-down": 36,
	"./symbols/scroll-down.svg": 36,
	"./symbols/twitter": 37,
	"./symbols/twitter.svg": 37,
	"./symbols/white-caret-left": 38,
	"./symbols/white-caret-left.svg": 38,
	"./symbols/white-caret-right": 39,
	"./symbols/white-caret-right.svg": 39,
	"./what-i-do": 40,
	"./what-i-do.jpg": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;